import { render } from "./bulk-product-upload.vue?vue&type=template&id=6ab955b4"
import script from "./bulk-product-upload.vue?vue&type=script&lang=js"
export * from "./bulk-product-upload.vue?vue&type=script&lang=js"

import "./bulk-product-upload.vue?vue&type=style&index=0&id=6ab955b4&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__